import React from "react";
import PropTypes from "prop-types";
import { DeleteButton, EditButton, Toolbar, useTranslate } from "react-admin";

const ShowToolbar = ({ redirect, ...props}) => {
    const translate = useTranslate();

    return (
        <Toolbar {...props} >
            <EditButton
                label={translate("ra.action.edit")}
                redirect={redirect}
                submitOnEnter={true}
            />
            <DeleteButton
                label={translate("ra.action.delete")}
            />
        </Toolbar>
    )
};

ShowToolbar.propTypes = {
    redirect: PropTypes.string,
};

ShowToolbar.defaultProps = {
    redirect: "show",
};

export default ShowToolbar;
